import React from 'react';
import { IInternalContactData } from '../../../../types/contacts/IInternalContact';
import { EditInternalOrderContactForm } from './EditInternalOrderContactForm';

interface EditInternalContactContainerProps {
  editContact: IInternalContactData | null;
  setEditContact: React.Dispatch<React.SetStateAction<IInternalContactData | null>>;
}
export const EditInternalContactContainer: React.FC<EditInternalContactContainerProps> = ({
  editContact,
  setEditContact,
}) => {
  if (!editContact) {
    return null;
  }
  return <EditInternalOrderContactForm editContact={editContact} setEditContact={setEditContact} />;
};
